/**
 * /dashboard — refonte « bonnes affaires » du 2026-09-14.
 *
 * Le tableau de bord montre ce que le compte suit : les bonnes affaires du
 * moment. Les cartes viennent de GET /api/listings/affaires, qui masque selon
 * la connexion (plus de marge ni d'abonnement depuis le 2026-10-22). Le retour
 * de paiement Stripe ci-dessous est laissé tel quel : inerte sans paiement.
 *
 * Retirés : le « Score IA moyen » (score retiré des affichages publics), la
 * barre de filtres doublon de /explore, et le mur flouté du compte gratuit —
 * un flou CSS ne masque rien, la réponse réseau restait lisible
 * (cf. frontend/CLAUDE.md, « Plans et gating »).
 */
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Page from '../components/Layout/Page';
import BandeauAffaires from '../components/Affaires/BandeauAffaires';
import useAffaires from '../components/Affaires/useAffaires';
import { nombre } from '../components/Affaires/format';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import './ComptePages.css';

export default function DashboardPage() {
  const [stats, setStats] = useState(null);
  const [banniere, setBanniere] = useState(null);
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { donnees: affaires } = useAffaires({ par_page: 1 });

  /* Activation de l'abonnement au retour de Stripe. */
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sessionId = params.get('session_id');
    if (params.get('success') !== '1' || !sessionId) return;
    navigate('/dashboard', { replace: true });
    api.post(`/api/subscriptions/activate-session?session_id=${encodeURIComponent(sessionId)}`)
      .then((res) => {
        setBanniere({ ok: true, texte: `Abonnement ${res.data?.plan_type || ''} activé : les liens des annonces sont débloqués.` });
        return api.get('/api/dashboard/stats');
      })
      .then((res) => { if (res?.data) setStats(res.data); })
      .catch(() => setBanniere({ ok: true, texte: 'Paiement reçu : votre abonnement sera activé dans quelques instants.' }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    api.get('/api/dashboard/stats').then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <Page
      titre={`Bonjour ${user?.username || ''}`.trim()}
      chapeau="Les voitures vendues sous leur valeur, en ce moment."
    >
      {banniere && (
        <div className="zk-alerte ok" role="status" style={{ marginBottom: 16 }}>
          {banniere.texte}
        </div>
      )}

      <div className="zk-cpt-tuiles">
        <div className="zk-cpt-tuile">
          <p>Bonnes affaires en ce moment</p>
          <b>{affaires ? nombre(affaires.total) : '—'}</b>
        </div>
        <div className="zk-cpt-tuile">
          <p>Nouvelles annonces aujourd’hui</p>
          <b>{stats ? nombre(stats.new_listings_today || 0) : '—'}</b>
        </div>
        <div className="zk-cpt-tuile">
          <p>Meilleur écart du jour</p>
          <b className="argent">{stats?.best_discount_today ? `−${stats.best_discount_today} %` : '—'}</b>
        </div>
      </div>

      <nav className="zk-cpt-raccourcis" aria-label="Mon compte">
        <Link to="/explore">Toutes les bonnes affaires</Link>
        <Link to="/favoris">Mes favoris</Link>
        <Link to="/alerts">Mes alertes</Link>
        <Link to="/historique">Historique</Link>
      </nav>

      <BandeauAffaires titre="Les meilleures affaires du moment" taille={8} />

    </Page>
  );
}
